import { useEffect, useState } from "react"; 

import NavBar from '../components/NavBar/NavBar'
import Banner from '../Componentes/Banners/Banner';
import UsoDelEquipo from '../Componentes/UsoDelEquipo/UsoDelEquipo';
import AlfinalizarElTrabajo from '../Componentes/AlFinalizarElTrabajo/AlFinalizarElTrabajo';
import Video from '../Componentes/Video/video';
import ManualesYDocumentos from '../Componentes/ManualesYDocumentos/ManuealesYDocumentos';
import RedesSociales from '../Componentes/RedesSociales/RedesSociales';
import Footer from '../Componentes/Footer/Footer'
import InfoPrincipal from '../Componentes/InfoPrincipal/InfoPrincipal';

import { obtenerDataBanner } from '../Componentes/infoJsons/infoBanner.js'
import { obtenerInfoPrin_AS530R } from '../Componentes/infoJsons/infoPrincipal.js'
import { obtenerUSO_AS530R } from '../Componentes/infoJsons/infoUsoDelEquipo.js'
import { obtenerAlfinalizarAS530R } from "../Componentes/infoJsons/infoAlFinalizar.js";

const AS710R = () => {

  //Banner
    const [data, setData] = useState([]);
  //

  //inFo Principal
    const [infoPrinc, setInfoPrinc] = useState([]);
  //

  //UsoDelEquipo
    const [USO_AS510B, setUSO_AS510B] = useState([]);
  //

  //AL FINALIZAR EL TRABAJO
    const [final, setFinal] = useState([]);
  //

    useEffect(() => {

        //Banner
        obtenerDataBanner().then(myJson => {setData(myJson);});

        //INFOPRINCIPAL
        obtenerInfoPrin_AS530R().then(infoPrincipal => {setInfoPrinc(infoPrincipal);});

        //USODELEQUIPO
        obtenerUSO_AS530R().then(uso => {setUSO_AS510B(uso);});
        //

        //AL FINALIZAR EL TRABAJO
        obtenerAlfinalizarAS530R().then(final => {setFinal(final);});
        //

    }, []);

    const listas = [
    ]

    const listasDesc2 = [
      "Aprender muy rápido a usarla y mantenerla, porque es muy sencilla.",
      "Limpiar superficies sobre 5.000 m2 con gran eficiencia debido a la duración de la batería y la capacidad de los estanques.",
      "Limpiar espacios reducidos como pasillos debido a su tamaño compacto.",
      "Controlar fácilmente la AS530R porque posee un Panel de control fácil de usa con pantalla y botones intuitivos."
    ]

    const listasDesc3 = []

    const videos = [
        "https://nilfiskchile.cl/assets/videos/F-AS530R/AS530R.mp4"
      ];
      
      const posters = [
        "https://nilfiskchile.cl/assets/videos/F-AS530R/as530r-video.jpg"
      ];
      
      const thumbnails = [
        "https://nilfiskchile.cl/assets/videos/F-AS530R/as530r-video.jpg"
      ];

      const elementosCarrusel = [
        {
          imgSrc: "https://nilfiskchile.cl/assets/img/FregadoraViperAS530R/Manuales/catalogo.jpg",
          pdf: "https://nilfiskchile.cl/assets/img/FregadoraViperAS530R/Manuales/AS530R_Catalogo.pdf",
          label: 'Catálogo',
        },
        {
          imgSrc: "https://nilfiskchile.cl/assets/img/FregadoraViperAS530R/Manuales/uso-y-mantencion.jpg",
          pdf: "https://nilfiskchile.cl/assets/img/FregadoraViperAS530R/Manuales/AS530R_Uso_Mantencion.pdf",
          label: 'Uso y Mantención',
        },
        {
          imgSrc: "https://nilfiskchile.cl/assets/img/FregadoraViperAS530R/Manuales/ficha-tecnica.jpg",
          pdf: "https://nilfiskchile.cl/assets/img/FregadoraViperAS530R/Manuales/AS530R_Ficha_Tecnica.pdf",
          label: 'Ficha Técnica',
        }
      ];

      
    return (      
        <div>
            <NavBar/>
            <Banner imageClass="BannerBarredora" titulo={data.length > 0 ? data[0].tituloBarredora : ""} />
            <InfoPrincipal data={infoPrinc} listas={listas} listasDesc2={listasDesc2} listasDesc3={listasDesc3}/>
            <UsoDelEquipo data={USO_AS510B}/>
            <AlfinalizarElTrabajo data={final} />
            <Video videos={videos} posters={posters} thumbnails={thumbnails}  />
            <ManualesYDocumentos elementosCarrusel={elementosCarrusel} />
            <RedesSociales />
            <Footer />
        </div>
    );
};

export default AS710R;